"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styles_1 = require("@mui/material/styles");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var react_i18next_1 = require("react-i18next");
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var IsOnlineField_1 = __importDefault(require("./IsOnlineField"));
var EditableName_1 = __importDefault(require("../common/EditableName"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var userPermissions_1 = require("@/Hooks/userPermissions");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Popover_1 = __importDefault(require("@mui/material/Popover"));
var List_1 = __importDefault(require("@mui/material/List"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var SortArrayContext_1 = require("./SortArrayContext");
var CustomDatagrid_1 = require("./CustomDatagrid");
var SelectInputPlayerGroup = function (_a) {
    var playerGroups = _a.playerGroups, onGroupsUpdated = _a.onGroupsUpdated, onGroupChange = _a.onGroupChange, permissions = _a.permissions;
    var record = (0, react_admin_1.useRecordContext)();
    var _b = (0, react_1.useState)(record.player_group_id), selectedGroupId = _b[0], setSelectedGroupId = _b[1];
    var _c = (0, react_1.useState)(function () {
        var group = playerGroups.find(function (group) { return group.id === record.player_group_id; });
        return group ? group.name : "";
    }), groupName = _c[0], setGroupName = _c[1];
    var logger = q_play_core_1.logManager.getLogger();
    var hasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var _d = (0, react_1.useState)(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var allowedGroups = (0, react_1.useMemo)(function () {
        return playerGroups.filter(function (group) {
            return hasPermission("resource-group-manager", group.id) ||
                hasPermission("global-players-manager", undefined, "global");
        });
    }, [playerGroups, hasPermission]);
    var onGroupNameSave = function (id, newName) { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedNewName, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trimmedNewName = newName.trim();
                    if (!trimmedNewName || trimmedNewName === groupName) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.updatePlayerGroupName(id, trimmedNewName)];
                case 2:
                    _a.sent();
                    onGroupsUpdated();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Failed to update group name:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleIconClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function (event) {
        event.stopPropagation();
        setAnchorEl(null);
    };
    var onChangeHandler = function (group, event) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedGroup;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.stopPropagation();
                    selectedGroup = allowedGroups.find(function (g) { return g.id === group.id; });
                    if (!selectedGroup) return [3 /*break*/, 2];
                    setSelectedGroupId(group.id);
                    setGroupName(group.name);
                    return [4 /*yield*/, ApiManager_1.default.updatePlayerGroup(Number(record.id), group.id)];
                case 1:
                    _a.sent();
                    handleClose(event);
                    if (onGroupChange)
                        onGroupChange(group.id, group.name);
                    return [3 /*break*/, 3];
                case 2:
                    logger.error("Attempted to select a group that is not allowed");
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var updatedGroup = allowedGroups.find(function (group) { return group.id === selectedGroupId; });
        if (updatedGroup) {
            setGroupName(updatedGroup.name);
        }
    }, [allowedGroups, selectedGroupId]);
    return (react_1.default.createElement(react_admin_1.Form, null,
        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSelectInputTheme },
            react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "10px" } },
                react_1.default.createElement(EditableName_1.default, { id: selectedGroupId, name: groupName, onSave: onGroupNameSave, style: { flexGrow: 1, background: "#FFFFFF", fontSize: "14px" }, key: selectedGroupId, permissions: permissions, type: types_1.ResourceType.PLAYER }),
                react_1.default.createElement(AccessControl_1.default, { resourceId: selectedGroupId, resourceType: "playerGroups", optionalPermissions: ["global-players-manager", "resource-group-manager"] },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronDown, onClick: function (event) {
                            event.stopPropagation();
                            handleIconClick(event);
                        }, style: { cursor: "pointer" } }),
                    react_1.default.createElement(Popover_1.default, { open: Boolean(anchorEl), anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        }, transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        }, sx: {
                            borderRadius: "10px",
                            ".MuiPaper-root": {
                                borderRadius: "10px"
                            }
                        } },
                        react_1.default.createElement(List_1.default, { component: "nav", "aria-label": "player group selection", style: { fontFamily: "Geomanist", color: "var(--info-color)", overflow: "hidden", padding: "0" } }, allowedGroups.length > 0 && (allowedGroups.map(function (group) { return (react_1.default.createElement(ListItemButton_1.default, { key: group.id, onClick: function (event) {
                                event.stopPropagation();
                                onChangeHandler(group, event);
                            } },
                            react_1.default.createElement(ListItemText_1.default, { primary: group.name }))); })))))))));
};
var PlayerPresentations = function (_a) {
    var setSelectedPlayer = _a.setSelectedPlayer, toggleProp = _a.toggleProp;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return null;
    Object.keys(record).filter(function () {
        if (Array.isArray(record.player_presentations) && record.player_presentations.length > 2) {
            var firstTwoPresentations = record.player_presentations.slice(0, 2);
            record.player_presentations = firstTwoPresentations;
        }
    });
    if (!Array.isArray(record.player_presentations) || record.player_presentations.length === 0) {
        return (react_1.default.createElement("div", { style: { cursor: "pointer", width: "20px" }, onClick: function () {
                setSelectedPlayer(record);
                toggleProp();
            } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })));
    }
    if (record.player_presentations.length <= 2) {
        return (react_1.default.createElement(react_admin_1.ArrayField, { source: "player_presentations" },
            react_1.default.createElement("div", { className: "d-flex align-items-center" },
                react_1.default.createElement(react_admin_1.SingleFieldList, { className: "d-flex flex-nowrap" },
                    react_1.default.createElement(react_admin_1.TextField, { source: "presentation_name" })),
                react_1.default.createElement("div", { style: { cursor: "pointer" }, onClick: function () {
                        setSelectedPlayer(record);
                        toggleProp();
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: "var(--info-color)" })))));
    }
};
var CheckBoxAction = function (_a) {
    var onCheckBoxTick = _a.onCheckBoxTick;
    var selectedIds = (0, react_admin_1.useListContext)().selectedIds;
    (0, react_1.useEffect)(function () {
        onCheckBoxTick(selectedIds);
    }, [selectedIds]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
var generateSortFields = function (sortArray) {
    if (sortArray.length == 2) {
        return [
            { field: sortArray[0], order: sortArray[1] }
        ];
    }
    else if (sortArray.length == 4) {
        return [
            { field: sortArray[0], order: sortArray[1] },
            { field: sortArray[2], order: sortArray[3] }
        ];
    }
    else {
        return [];
    }
};
var PlayersListView = function (props) {
    var playerGroups = props.playerGroups, refreshPlayerGroups = props.refreshPlayerGroups, permissions = props.permissions, addPresentationModalShown = props.addPresentationModalShown, bulkActionPlayerIds = props.bulkActionPlayerIds, currentPlayerId = props.currentPlayerId, type = props.type, setBulkActionPlayerIds = props.setBulkActionPlayerIds, setConfirmationModalOpened = props.setConfirmationModalOpened, setPlayerDetailsModalShown = props.setPlayerDetailsModalShown, setCurrentGroupId = props.setCurrentGroupId, setSelectedPlayer = props.setSelectedPlayer, setResourceName = props.setResourceName;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var filters = [react_1.default.createElement(react_admin_1.SearchInput, { source: "name", alwaysOn: true, key: "queryFilter", placeholder: t("Search") })];
    var _a = (0, react_1.useState)(false), checkBoxIsActive = _a[0], setCheckBoxIsActive = _a[1];
    var directPlayerPermissionResourceType = types_1.ResourceType.PLAYER.toLowerCase() + "s";
    var hasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var sortArray = (0, SortArrayContext_1.useSortArray)().sortArray;
    var _b = (0, react_1.useState)(generateSortFields(sortArray)), sortFields = _b[0], setSortFields = _b[1];
    (0, react_1.useEffect)(function () {
        if (addPresentationModalShown) {
            setPlayerDetailsModalShown(false);
        }
    }, [addPresentationModalShown]);
    var onCheckBoxTickHandler = function (selectedIds) {
        if (selectedIds.length > 0) {
            setCheckBoxIsActive(true);
            setBulkActionPlayerIds(selectedIds);
        }
        else {
            setCheckBoxIsActive(false);
            setBulkActionPlayerIds([]);
        }
    };
    var handleGroupChange = function (groupId, groupName) {
        setCurrentGroupId(groupId);
        setResourceName(groupName);
    };
    var actionPermissions = (0, react_1.useMemo)(function () {
        return {
            canRead: bulkActionPlayerIds.every(function (id) { return hasPermission(permissions.read, id, directPlayerPermissionResourceType); }),
            canWrite: bulkActionPlayerIds.every(function (id) { return hasPermission(permissions.write, id, directPlayerPermissionResourceType); }),
            canManage: bulkActionPlayerIds.every(function (id) { return hasPermission(permissions.manage, id, directPlayerPermissionResourceType); }),
            canManageGroup: bulkActionPlayerIds.every(function (id) {
                return hasPermission("resource-group-manager", id, directPlayerPermissionResourceType) ||
                    hasPermission("global-players-manager", undefined, "global");
            }),
        };
    }, [bulkActionPlayerIds, directPlayerPermissionResourceType, hasPermission]);
    return (react_1.default.createElement(react_admin_1.ListBase, { queryOptions: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: true,
            refetchInterval: 1000 * 60
        } },
        react_1.default.createElement("div", { className: Players_module_css_1.default.searchbar_container },
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSearchInputTheme },
                react_1.default.createElement(react_admin_1.FilterForm, { filters: filters })),
            react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", className: "".concat(Players_module_css_1.default.filter_button, " d-flex align-items-center justify-content-center") },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBarsFilter, style: { fontSize: "28px" }, color: "var(--info-color)" }))),
        react_1.default.createElement("div", { className: Players_module_css_1.default.list_view_quick_actions_container },
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.manage, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Restart"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canWrite, onClick: function () { return props.onBulkActionHandler("rebootDevice"); } }),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Update"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canManage, onClick: function () { return props.onBulkActionHandler("updateSoftware"); } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.read, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Screen Capture"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)", whiteSpace: "nowrap" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canRead, onClick: function () { return props.onBulkActionHandler("screenCapture"); } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.write, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Update Presentation"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)", whiteSpace: "nowrap" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canWrite, onClick: function () { return props.onBulkActionHandler("reloadContent"); } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.manage, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Delete"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canManageGroup, onClick: function () {
                        if (bulkActionPlayerIds.length == 1) {
                            setSelectedPlayer({ id: bulkActionPlayerIds[0] });
                            setConfirmationModalOpened(true);
                        }
                        else {
                            props.toggleDeleteMultipleConfirmationModal();
                        }
                    } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.manage, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Add event"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canManageGroup, onClick: function () {
                        setSelectedPlayer(null);
                        props.toggleAddEvents();
                    } }))),
        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
            react_1.default.createElement(CustomDatagrid_1.CustomDatagrid, { hover: false, rowClick: function (id, basePath, record) {
                    setSelectedPlayer(record);
                    setPlayerDetailsModalShown(true);
                    return false;
                }, sx: RAStyles_1.RaDataGridSx, bulkActionButtons: react_1.default.createElement(CheckBoxAction, { onCheckBoxTick: onCheckBoxTickHandler }), sortfields: sortFields, setsortfields: setSortFields },
                react_1.default.createElement(react_admin_1.TextField, { source: "id", label: t("ID"), sx: __assign(__assign({}, RAStyles_1.RaTextFieldSx), { fontFamily: "Geomanist" }) }),
                react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), sx: __assign(__assign({}, RAStyles_1.RaTextFieldSx), { fontFamily: "Geomanist-Bold" }) }),
                react_1.default.createElement(react_admin_1.WrapperField, { label: t("Group"), sortBy: "player_groups.name" },
                    react_1.default.createElement(SelectInputPlayerGroup, { playerGroups: playerGroups, onGroupsUpdated: refreshPlayerGroups, permissions: permissions, onGroupChange: handleGroupChange })),
                react_1.default.createElement(react_admin_1.WrapperField, { label: t("Presentations"), sortable: false },
                    react_1.default.createElement(PlayerPresentations, { setSelectedPlayer: setSelectedPlayer, toggleProp: props.togglePlayerDetailsModal })),
                react_1.default.createElement(react_admin_1.TextField, { label: t("Type"), sortBy: "device_types.name", source: "device_type.name", sx: RAStyles_1.RaTextFieldSx }),
                react_1.default.createElement(react_admin_1.TextField, { source: "player_statuses.player_version", label: t("Version"), sx: RAStyles_1.RaTextFieldSx }),
                react_1.default.createElement(react_admin_1.DateField, { label: t("Last online"), source: "player_statuses.updated_at", showTime: true, options: { hour12: false } }),
                react_1.default.createElement(react_admin_1.FunctionField, { label: t("Status"), render: function () { return react_1.default.createElement(IsOnlineField_1.default, { view: "list" }); }, sortBy: "player_statuses.updated_at" }),
                react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(AccessControl_1.default, { resourceType: directPlayerPermissionResourceType, optionalPermissions: __spreadArray(__spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true), ["edit-user-management"], false) },
                        react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () {
                                setSelectedPlayer(record);
                                setPlayerDetailsModalShown(true);
                            }, onDelete: props.deleteSinglePlayer, onManageResourceAccess: function (id, name) { return props.openResourceAccessModal(id, name, "Resource"); }, onManageGroupAccess: function (id, name) { return props.openResourceAccessModal(id, name, "Group"); }, resourceId: currentPlayerId, type: type, resourceType: types_1.ResourceType.PLAYER }))); }, sortable: false }))),
        react_1.default.createElement(Pagination_1.default, null)));
};
exports.default = PlayersListView;
